import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IStartCheckoutSessionPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function startCheckoutSession(payload: IStartCheckoutSessionPayload) {
  return axios.post('/api/v1/credits/start_checkout_session', convertToSnakeCase(payload), config)
}
